import { useMutation } from '@urql/vue';

import type { VerificationResponse, VerificationTypes } from '~/types/verification';

import { requestSMSVerificationCode } from '~/graphql/documents/core';
import { VERIFICATION_TYPES } from '~/types/verification';

export const useRequestVerification = () => {
  const { executeMutation } = useMutation(requestSMSVerificationCode);

  const requestPhoneVerification = async ({ phoneNumber }: { phoneNumber: string }): Promise<VerificationResponse> => {
    const { error } = await executeMutation({
      input: {
        phoneNumber,
      },
    });
    if (error) {
      return { success: false, error };
    }
    return { success: true, error: null };
  };
  const requestVerification = async ({ verificationMethod, authMethodValue }: { verificationMethod: VerificationTypes; authMethodValue: string }) => {
    if (verificationMethod === VERIFICATION_TYPES.PHONE) {
      return await requestPhoneVerification({ phoneNumber: authMethodValue });
    }
  };

  return { requestVerification };
};
